module.exports = __webpack_public_path__ + "static/media/LOGOGRAM INDONESIANA HITAM.fb09686f.png";